import { useContext } from 'react';

import MealItemForm from './MealItemForm';
import classes from './MealItem.module.css';
import CartContext from '../../../store/cart-context';

const MealItem = (props) => {
  
  const cartCtx = useContext(CartContext);

  const price = `$${props.price.toFixed(2)}`;

  const addToCartHandler = amount => {
    cartCtx.addItem({
      id: props.id,
      name: props.name,
      amount: amount,
      price: props.price,
      description: props.description
    });
  };

  return (
    <div className={classes.meal} >
    
      <div className={classes.clickarea} onClick={props.onClick}>
          <h3>{props.name}</h3>
        <div className={classes.description}>{props.description}</div>
        <div className={classes.price}>{price}</div>
      </div>
      <div className={classes.formcontainer}>
        <MealItemForm id={props.id} onAddToCart={ addToCartHandler } />
      </div>
    </div>
  );
};

export default MealItem;